import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AnnouncementInfo } from './announcementInfo';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  private apiUrl = environment.apibaseUrl + '/announcement';

  constructor(private http: HttpClient) { }

  createAnnouncement(announcement: AnnouncementInfo) {
    return this.http.post(this.apiUrl, announcement);
  }

  getAnnouncementList() {
    return this.http.get(this.apiUrl);
  }

  getAnnouncement(id: number) {
    return this.http.get(this.apiUrl + '/' + id);
  }

  deleteAnnouncement(id: number) {
    return this.http.delete(this.apiUrl + '/?announcementid=' + id);
  }

  saveAnnouncementImages(announcementImageFile) {
    const FileDetails = new FormData();
    FileDetails.append('resourceFile', announcementImageFile);
    return this.http.post(this.apiUrl + '/saveAnnouncementImages', FileDetails);
  }

}
